import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateAction {
  label: string;
  to: string;
}

interface EmptyStateProps {
  /** lucide-react icon component to display above the heading. */
  icon?: LucideIcon;
  heading: string;
  body?: string;
  action?: EmptyStateAction;
}

/** Centred empty-state card with optional icon, description, and CTA link. */
export function EmptyState({ icon: Icon, heading, body, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {Icon && <Icon size={48} className="text-gray-300 mb-4" />}
      <h3 className="text-lg font-semibold text-gray-700 mb-2">{heading}</h3>
      {body && <p className="text-sm text-gray-500 max-w-sm mb-6 m-0">{body}</p>}
      {action && (
        <Link
          to={action.to}
          className="inline-flex items-center px-5 py-2.5 bg-brand-500 hover:bg-brand-600 text-white rounded-lg font-semibold text-sm transition-colors mt-4"
        >
          {action.label}
        </Link>
      )}
    </div>
  );
}
